import { delay } from "src/common/delay";
import {
  applyRequest,
  makeFilters,
  testStrPart,
} from "src/components/ReactiveTable/loaders/clientDataCtrl";
import { RtConfig } from "src/components/ReactiveTable/RtConfig";
import { RtLoaderFn } from "src/components/ReactiveTable/RtLoader";
import { RtRequest } from "src/components/ReactiveTable/RtRequest";
import { RtResponse } from "src/components/ReactiveTable/RtResponse";

import { generateDemoData } from "./demoDataGenerator";
import { DemoFilters, ZDemoData, zDemoData } from "./demoDataTypes";

const key = "DemoData";

export const demoDataLoader: RtLoaderFn<ZDemoData, DemoFilters> = async (
  request,
) => loadDemoDataPage(request);

const loadDemoDataPage = async (
  request: RtRequest<DemoFilters>,
): Promise<RtResponse<ZDemoData>> => {
  await delay(1000);
  const text = window.localStorage.getItem(key);
  if (!text)
    return {
      rows: [],
      totalRows: 0,
    };
  const json = JSON.parse(text);
  const all = zDemoData.array().parse(json);
  return applyRequest(all, request, {
    sorters: {
      country: (a, b) => a.country.value.localeCompare(b.country.value),
    },
    isFiltered: makeFilters<ZDemoData, DemoFilters>({
      name: testStrPart<ZDemoData>("name"),
      countryCodes: (row, codes) =>
        codes ? codes.includes(row.country.value) : true,
      minCount: (row, count) => row.count >= count,
      maxCount: (row, count) => row.count <= count,
    }),
  });
};

export const createNewDemoData = async (count: number) => {
  const data = generateDemoData(count);
  const text = JSON.stringify(data);
  window.localStorage.setItem(key, text);
};

export const deleteDemoData = async () => {
  await delay(1000);
  window.localStorage.removeItem(key);
};

const configKey = "DemoConfig";

export const saveDemoConfig = async (config: RtConfig<DemoFilters> | null) => {
  if (!config) {
    window.localStorage.removeItem(configKey);
  } else {
    window.localStorage.setItem(configKey, JSON.stringify(config));
  }
};
export const loadDemoConfig =
  async (): Promise<RtConfig<DemoFilters> | null> => {
    const text = window.localStorage.getItem(configKey);
    if (!text) return null;
    return JSON.parse(text) as RtConfig<DemoFilters>;
  };
